import React from "react";
import { Loader2, Award } from "lucide-react";
import { useTranslation } from "../i18n";

const WorkvivoLoading = () => {
  const { t } = useTranslation("nav");
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="w-20 h-20 mb-6 org-gradient rounded-2xl flex items-center justify-center shadow-lg">
        <Award className="w-12 h-12 text-white" />
      </div>
      
      <h1 className="text-3xl font-bold text-gray-800 mb-2">{t("workvivo_loading.title")}</h1>
      
      <div className="w-full max-w-md mt-8">
        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
          <div className="p-4 org-gradient">
            <h2 className="text-xl font-bold text-white">{t("workvivo_loading.connecting")}</h2>
          </div>
          
          <div className="p-8 flex flex-col items-center">
            <Loader2 className="w-16 h-16 text-purple-600 animate-spin mb-6" />
            <p className="text-gray-700 text-center mb-4">
              {t("workvivo_loading.establishing")}
            </p>
            <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
              <div className="org-bg-primary h-2 rounded-full animate-pulse" style={{ width: '60%' }}></div>
            </div>
            <p className="text-xs text-gray-500">{t("workvivo_loading.may_take_moments")}</p>
          </div>
        </div>
        
        <div className="mt-8 grid grid-cols-3 gap-4">
          <div className="bg-white p-4 rounded-2xl shadow-sm text-center opacity-50">
            <p className="text-sm font-medium text-gray-700">{t("workvivo_loading.step_authenticating")}</p>
          </div>
          <div className="bg-white p-4 rounded-2xl shadow-sm text-center opacity-50">
            <p className="text-sm font-medium text-gray-700">{t("workvivo_loading.step_syncing_users")}</p>
          </div>
          <div className="bg-white p-4 rounded-2xl shadow-sm text-center opacity-50">
            <p className="text-sm font-medium text-gray-700">{t("workvivo_loading.step_setting_up")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkvivoLoading;